<template>
  <router-view />
</template>

<script>
export default {
    name: "User",
    components: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss">
</style>

